export const InsertBlankPage = {
  "title": "Insert Blank Pages",
  "destination": "Destination",
  "beforePage": "Before page",
  "afterPage": "After page",
  "beginDocument": "Beginning of document",
  "endDocument": "End of document",
  "of": "of",
  "insertPageCount": "Insert Page Count"
}